// IBannerizationResponseData and IRelationshipsResponse types are not yet available
// from their original component location. Using local placeholders until types are migrated.
type IBannerizationResponseData = Record<string, unknown>;
type IRelationshipsResponse = Record<string, unknown>;

import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE, PERPETUAL_TOKEN } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { getCookie } from "@repo/shared-utils/common-utils";
import { IResponse, encryptedRequest } from "../core/api.client";

type IApiBannerizationResponseData = {
  success: boolean;
  displayStatus: boolean;
  lastUpdatedDate: number;
  module: string;
  channel: string;
  appversion: string;
  source: string;
  data: IBannerizationResponseData[];
};

export const getBannerizationLoggedInData = async (
  module: string,
  section: string,
  appVersion: string,
  languageCode?: string
): Promise<IResponse<IApiBannerizationResponseData>> => {
  // Check for perpetual token directly from cookie
  const pToken = getCookie(PERPETUAL_TOKEN) || "";

  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  const response = await encryptedRequest<IApiBannerizationResponseData>({
    method: "POST",
    url: API_PATHS.bannerizationDynamic,
    data: {
      module,
      section,
      mobileNo,
      appVersion,
      p_token: pToken,
      ...(languageCode && { lang: languageCode }),
    },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};

export const getEmiCardRelationStatus = async (
  mobileNo: string
): Promise<IRelationshipsResponse> => {
  // Check for perpetual token directly from cookie
  const pToken = getCookie(PERPETUAL_TOKEN) || undefined;

  const response = await encryptedRequest<IRelationshipsResponse>({
    method: "POST",
    url: API_PATHS.relationships,
    data: {
      mobileNo,
      p_token: pToken,
    },
  });
  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response.data;
};
